import type { FC } from "react";
import { useState, useEffect } from "react";
import { Text } from "@ecco/ui/text";
import { Grid } from "@ecco/ui/grid";
import { Box } from "@ecco/ui/box";
import { ContentLink } from "../../../cms/link/ContentLink";
import type { NavigationLink } from "@lib/contentful/mappers/mapNavigation";
import { NextImage } from "@ecco/ui/next-image";
import { styles } from "./CategoryTile.style";

interface CategoryTileProps {
    link: NavigationLink;
    imageSizes: string[];
    isLeftSide?: boolean;
    isVisible?: boolean;
}

export const CategoryTile: FC<CategoryTileProps> = ({
    link,
    imageSizes,
    isLeftSide = false,
    isVisible = false,
}) => {
    const [shouldLoadImage, setShouldLoadImage] = useState(isVisible);
    useEffect(() => {
        if (isVisible && !shouldLoadImage) {
            setShouldLoadImage(true);
        }
    }, [isVisible, shouldLoadImage]);
    return (
        <ContentLink {...styles.link} link={link.contentLink} w="full">
            <Grid {...styles.grid}>
                {shouldLoadImage && link.media && (
                    <Box {...styles.imageWrapper}>
                        <NextImage
                            src={link.media.url}
                            alt={link.media.alt}
                            layout="fill"
                            objectFit="cover"
                            sizes={imageSizes}
                            fill={true}
                        />
                    </Box>
                )}
                <Text {...(isLeftSide ? styles.textLabelLeft : styles.textLabelDefault)}>
                    {link.label}
                </Text>
                {link.description && <Text {...styles.textDescription}>{link.description}</Text>}
            </Grid>
        </ContentLink>
    );
};
